export const getInbox = state => state.inbox.inbox;